import { render, staticRenderFns } from "./LungLesionScoreAnalysisTable.vue?vue&type=template&id=8ee2701e&scoped=true&"
import script from "./LungLesionScoreAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./LungLesionScoreAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./LungLesionScoreAnalysisTable.vue?vue&type=style&index=0&id=8ee2701e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee2701e",
  null
  
)

export default component.exports